import { environment } from '@env/environment';
import { Injector } from '@angular/core';
import { AccountsService } from "../../services/accounts.service";

declare let gtag: Function;

function track(pageTitle: string) {
  const injector: Injector = (window as any)['injector'];
  if (!injector) {
    console.warn("Angular injector is not available for Google Analytics tracking");
    return;
  }
  
  const accountsService: AccountsService = injector.get(AccountsService);
  accountsService.getLogin().then((login) => {
    const company = login?.company;
    if (!company) {
      gtag('config', environment.values['googleAnalyticsId'], { page_title: pageTitle });
      return;
    }
    gtag('config', environment.values['googleAnalyticsId'], {
      custom_map: {
        'dimension1': 'winery_id',
        'dimension2': 'winery_name'
      },
      page_title: pageTitle,
      winery_id: company.id,
      winery_name: company.name
    });
  });
}

const ga = { track }

export { ga, track };
